<template>
	<dialog-model
		model
		ref="shareModel"
	>
		<div class="share">
			<div class="share-title " v-if="fileList.length">
				<span class="ellipsis">
					分享文件：{{fileList[0].resourceName}}
				</span>
				<span class="number" v-if="fileList.length > 1">
					等{{fileList.length}}个文件
				</span>
			</div>
			<div class="share-tips">保存二维码分享给好友</div>
			<div class="share-image" v-loading="loading">
				<img 
					:src="url" 
					v-if="url"
				/>
			</div>
			
			<div class="share-scan">
				<t-button width="203" nr @click="downloadImage">保存图片</t-button>
			</div>
		</div>
	</dialog-model>
</template>

<script type="text/javascript">
import DialogModel from '@/components/dialogModel'
import {
	resourceShare,
	createQrCode
} from '@/api/common';
import {
	mapState
} from 'vuex'
import {
	downloadFile
} from '@/utils'
export default {
	data() {
		return {
			url: '',
			loading: false,
			fileList: []
		}
	},
	components: {
		DialogModel
	},
	props: {
		from: String
	},
	computed: {
		...mapState(['userInfo'])
	},
	methods: {
		show(list) {
			this.fileList = list
			this.$refs.shareModel.show()
			this.loading = true
			resourceShare({
				resourceIds: list.map(l => l.resourceId).join(',')
			}).then(res => {
				const {sharedId} = res.data;
				this.getCode(sharedId)
			})
		},
		downloadImage() {
			
			downloadFile(this.url, '分享图片')
		},
		getCode(sharedId) {
			const isOfficial = this.from == 'official' ? 'o' : 'n'
			createQrCode({
				page: 'resources/pages/resourceShare/resourceShare',
				scene: `sId=${sharedId}&tId=${this.userInfo.id}&s=${isOfficial}&f=w`
			}).then(res => {
				const {image_url} = res.data
				this.url = image_url.replace('heya-reading.gsxcdn.com', 'heya-reading.oss-cn-beijing.aliyuncs.com')
				this.loading = false
			})
		}
	},
	mounted() {

	}
}
</script>

<style lang="less" scoped>
.share {
	&-title {
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #11142D;
		line-height: 32px;
		text-align: center;
		width: 80%;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		.number {
			word-break: keep-all;
		}
	}

	&-tips {
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FF3A40;
		line-height: 32px;
		margin-top: 4px;
		text-align: center;
	}
	&-image {
		width: 160px;
		height: 160px;
		margin: 24px auto 20px;
		img {
			width: 160px;
			height: 160px;
			display: block;
		}
	}
	&-scan {
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #212D44;
		line-height: 25px;
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			width: 29px;
			height: 29px;
			margin-right: 5px;
		}
	}
}
</style>